import { useEffect, useRef } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Scrolls to top on PUSH/REPLACE navigation (Link, navigate()).
 * Excludes: refresh, back/forward (popstate).
 * Place once inside your Router (e.g. BrowserRouter) to apply globally.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()
  const navigationType = useNavigationType()
  const isInitialMount = useRef(true)

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
      return // skip on refresh / initial load
    }

    if (navigationType === 'POP') return // skip on back/forward

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname, navigationType])

  return null
}
